export default {
      id: "status_calendar_yellow-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#status_calendar_yellow",
      toString: function () {
        return this.url;
      }
    }